import { useEffect, useRef } from "react";


export function useVisibleRefresh(onVisible, enabled = true) {
  const callback = useRef(onVisible);
  callback.current = onVisible;

  useEffect(() => {
    if (!enabled || typeof document === "undefined") return undefined;

    const handler = () => {
      if (document.visibilityState === "visible") callback.current();
    };

    document.addEventListener("visibilitychange", handler);

    window.addEventListener("pageshow", handler);

    return () => {
      document.removeEventListener("visibilitychange", handler);
      window.removeEventListener("pageshow", handler);
    };
  }, [enabled]);
}
